document.addEventListener('DOMContentLoaded', () => {
  // 対象「js-pdf-viewer」を対象とする
  const pdfViewers = Array.from(document.querySelectorAll('.js-pdf-viewer'))
  pdfViewers.forEach((v) => {
    const enableSlider = v.dataset.slider === 'true'
    const pdfLinks = Array.from(v.querySelectorAll('a'))
                          .filter(a => a.href.toLowerCase().endsWith('.pdf'));
    pdfLinks.forEach((a, i) => {
      // ファイルタイプがpdfのみを対象とする
      const viewer = new PdfViewer();
      viewer.initialize(a, enableSlider);
    })
  })
})

class PdfViewer {
  constructor() {
    this.pdfDoc = null;
    this.pageNum = 1;
    this.pageRendering = false;
    this.pageNumPending = null;
    this.enableSlider = false;
    this.isLeftClick = false
  }

  initialize(linkElement, enableSlider) {
    if (!linkElement || !linkElement.href || !linkElement instanceof HTMLAnchorElement) {
      console.error('Invalid <a> element passed to PdfViewer.');
      return;
    }

    const pdfUrl = linkElement.href;
    this.enableSlider = enableSlider;

    // ラッパーHTMLを作成
    const container = document.createElement('div');
    container.className = 'pdfViewer_wrapper';
    container.innerHTML = `
      <div class="pdfViewer" data-src="${pdfUrl}">
        <canvas class="pdfViewer_canvas js-pdfViewer_canvas"></canvas>
        <div class="pdfViewer_slider_wrapper">
          <input type="range" class="pdfViewer_slider js-pdfViewer_slider" min="1" value="1">
          <canvas class="pdfViewer_preview" width="100" height="140"></canvas>
        </div>
        <div class="pdfViewer_controls">
          <button class="js-pdfViewer_controls_prev"><i class="fa-solid fa-caret-left"></i></button>
          <span class="pdfViewer_controls_info js-pdfViewer_controls_info">読み込み中...</span>
          <button class="js-pdfViewer_controls_next"><i class="fa-solid fa-caret-right"></i></button>
          <button class="js-pdfViewer_controls_fullscreen">
            <i class="fa-solid fa-expand"></i>
          </button>
        </div>
      </div>
    `;

    // DOMに差し替え
    linkElement.replaceWith(container);

    // キャンバスとコントロール取得
    const canvas = container.querySelector('.js-pdfViewer_canvas');
    const ctx = canvas.getContext('2d');
    const pageInfo = container.querySelector('.js-pdfViewer_controls_info');
    const slider = container.querySelector('.js-pdfViewer_slider');
    const previewCanvas = container.querySelector('.pdfViewer_preview');
    const previewCtx = previewCanvas.getContext('2d');
    if (this.enableSlider) {
      slider.addEventListener('input', () => {
        const pageNumber = parseInt(slider.value, 10);

        // スライダー位置に合わせてプレビュー位置を調整
        const percent = (pageNumber - 1) / (slider.max - 1);
        previewCanvas.style.left = `${percent * 100}%`;
        previewCanvas.style.display = 'block';

        this.pdfDoc.getPage(pageNumber).then((page) => {
          const viewport = page.getViewport({ scale: 0.2 }); // 小さいプレビュー用
          previewCanvas.width = viewport.width;
          previewCanvas.height = viewport.height;

          const renderContext = {
            canvasContext: previewCtx,
            viewport: viewport
          };
          page.render(renderContext);
        });
      })
      slider.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
          this.isLeftClick = true
        }
      })
      slider.addEventListener('mouseup', (e) => {
        if (this.isLeftClick && e.button === 0) {
          this.isLeftClick = false
          previewCanvas.style.display = 'none';

          const pageNumber = parseInt(slider.value, 10);
          if (this.pageNum != pageNumber) {
            this.queueRenderPage(pageNumber, canvas, ctx, pageInfo, slider)
          }
        }
      })
    } else {
      slider.style.display = 'none'
    }

    // PDF表示処理
    const loadPdf = (url) => {
      pdfjsLib.getDocument(url).promise.then((pdf) => {
        this.pdfDoc = pdf;
        slider.max = pdf.numPages;
        pageInfo.textContent = `ページ 1 / ${pdf.numPages}`;
        this.renderPage(1, canvas, ctx, pageInfo, slider);
      });
    };

    const fullscreenBtn = container.querySelector('.js-pdfViewer_controls_fullscreen')
    fullscreenBtn.addEventListener('click', () => {
      const viewerElement = container.querySelector('.pdfViewer')
      if (!document.fullscreenElement) {
        viewerElement.requestFullscreen().catch(err => {
          console.error(`フルスクリーンにできません: ${err.message}`)
        })
      } else {
        document.exitFullscreen()
      }
    });

    canvas.addEventListener('click', (event) => {
      const rect = canvas.getBoundingClientRect()
      const x = event.clientX - rect.left
      const half = rect.width / 2

      if (x > half) {
        container.querySelector('.js-pdfViewer_controls_next').click();
      } else {
        container.querySelector('.js-pdfViewer_controls_prev').click();
      }
    })

    // 描画処理
    this.renderPage = (num, canvas, ctx, pageInfo, slider) => {
      this.pageRendering = true;
      this.pageNum = num;

      this.pdfDoc.getPage(num).then((page) => {
        const viewport = page.getViewport({ scale: 1.5 });
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: ctx, viewport: viewport };
        const renderTask = page.render(renderContext);
        canvas.classList.remove('is-visible');

        renderTask.promise.then(() => {
          this.pageRendering = false;
          canvas.classList.add('is-visible');

          if (this.pageNumPending !== null) {
            this.renderPage(this.pageNumPending, canvas, ctx, pageInfo, slider);
            this.pageNumPending = null;
          }
        });
      });

      slider.value = num;
      pageInfo.textContent = `${num} / ${this.pdfDoc.numPages}`;
    };

    // ボタンクリック処理
    container.querySelector('.js-pdfViewer_controls_prev').addEventListener('click', () => {
      if (this.pageNum <= 1) return;
      this.queueRenderPage(this.pageNum - 1, canvas, ctx, pageInfo, slider);
    });

    container.querySelector('.js-pdfViewer_controls_next').addEventListener('click', () => {
      if (this.pageNum >= this.pdfDoc.numPages) return;
      this.queueRenderPage(this.pageNum + 1, canvas, ctx, pageInfo, slider);
    });

    this.queueRenderPage = (num, canvas, ctx, pageInfo, slider) => {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num, canvas, ctx, pageInfo, slider);
      }
    };

    // 読み込み開始
    loadPdf(pdfUrl);
  }
}
